<template>
  <section>
    <div class="article">
        <h1 class="article_title">{{ article.title }}</h1>
        <div class="article_content" v-html="article.content"></div>
        <br>
        <router-link to="/">


<div class="card">
  <div class="card-content">
    <div class="media">
      <div class="media-left">
        <figure class="image  is-64x64">
          <img src="https://translate.ameneko.com/translateIcon.png" alt="image">
        </figure>
      </div>
      <div class="media-content">
        <p class="title is-5">Memoey</p>
      </div>
    </div>
    <div class="content">   
        It is an application that translates your written notes and diaries into English. You can learn English in addition to notes and diaries.
    </div>
  </div>
</div>
</router-link>
        <br>
        <router-link to="/articles">To list of Memoey magazine</router-link>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import moment from 'moment'
export default {
  components: {},
  data() {
    return {
      article: null
    };
  },
  mounted() {
    this.fetchNotice();
  },
  methods: {
    fetchNotice() {
        let url = "https://translate.microcms.io/api/v1/articles_en/" + this.$route.params.id
        axios
            .get(url, {
            headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
            })
            .then(res => {
            this.article = res.data
            }).then(()=>{
                const title =  'How to say"' + this.article.title  +'"in Japanese?' + "｜Memoey"
                const description = 'How to say"' + this.article.title  +'"in Japanese?【Answer】' + this.article.content.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
                document.title = title
                document.querySelector("meta[property='og:title']").setAttribute('content', title)
                document.querySelector("meta[name='description']").setAttribute('content', description)
                document.querySelector("meta[property='og:description']").setAttribute('content', description)
            })
            .catch(err => {
            console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.article{
  padding:20px;
}
.card-content{
  padding: 8px;
}
h1{
  font-weight: bold;
  font-size: 1.2em;
  text-align: center;
  padding-bottom: 10px;
}
div >>> h2{
  font-weight: bold;
  font-size: 1.5em;
  padding-bottom: 10px;
}
div >>> h3{
  font-weight: bold;
  font-size: 1.2em;
  padding-top: 10px;
  padding-bottom: 10px;
}
div >>> p{
  padding: 10px;
  font-size:1.1em;
}


</style>